import type { RegisterCfdType } from '@vend/types/register'

export const CFD_TYPE: Record<Uppercase<RegisterCfdType>, RegisterCfdType> = {
  NONE: 'none',
  BYOD: 'byod',
  LSPAY: 'lspay',
}
